import { compareTags } from "../components/congregation/tags";
import { PseudoTag, Tag } from "../types/scheduling/tags";
import { Territory, TerritoryAddress, TerritoryRecord } from "../types/scheduling/territory";
import { SMPWUser } from "../types/smpw";
import User from "../types/user";

export type Taggable = Territory | User | SMPWUser | TerritoryAddress | TerritoryRecord;

export function isTerritory(t: Taggable): boolean {
  return (t as Territory).locality !== undefined;
}

export function isUser(t: Taggable): boolean {
  return (t as User).lastname !== undefined;
}

export function isSMPWUser(t: Taggable): boolean {
  return (t as SMPWUser).key_man !== undefined;
}

export function isAddress(t: Taggable): boolean {
  return (t as TerritoryAddress).line1 !== undefined;
}

export function isTerritoryRecord(t: Taggable): boolean {
  return (t as TerritoryRecord).end !== undefined;
}

export const filterTerritoryByTags = (t: Territory, tags: (Tag | PseudoTag)[], requireAll: boolean = false) => {
  if (!tags) return true;
  if (tags.some((tag) => tag === PseudoTag.all)) return true;
  if (tags.some((tag) => tag === PseudoTag.untagged)) return t.tags.length < 1;
  if (tags.some((tag) => tag === PseudoTag.non_business)) return !t.tags.some((t) => t.global && t.name === "business");

  // Filter out pseudo tags for actual tag matching
  const actualTags = tags.filter((tag) => typeof tag !== "number");
  if (actualTags.length === 0) return true;

  if (requireAll) {
    // AND mode: territory must have ALL selected tags
    return actualTags.every((tag) => t.tags.some((tt) => compareTags(tt, tag)));
  } else {
    // OR mode: territory must have ANY selected tag
    return t.tags.some((tt) => actualTags.some((tag) => compareTags(tt, tag)));
  }
};

export const filterTerritoryRecordsByTags = (r: TerritoryRecord, rtags: (Tag | PseudoTag)[]) => {
  if (!rtags) return true;
  if (rtags.some((tag) => tag === PseudoTag.all)) return true;
  if (rtags.some((tag) => tag === PseudoTag.untagged)) return r.tags.length < 1;
  return r.tags.some((tt) => rtags.some((tag) => compareTags(tt, tag)));
};
